var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"unknown-word-button",class:_vm.classes,on:{"click":function($event){return _vm.CHANGE_WORD_STATUS({ wordId: _vm.wordId, status: 'unknown'})}}},[_vm._v("U")])
}
var staticRenderFns = []

export { render, staticRenderFns }